import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "card-header border-0 cursor-pointer bg-success",
      role: "button",
      "data-bs-target": "#nid_report",
      "aria-expanded": "true",
      "aria-controls": "form"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
        /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "NID Report")
      ])
    ])
  ])
], -1)
const _hoisted_3 = { class: "card-body pt-5 pb-5" }
const _hoisted_4 = { class: "row mb-7" }
const _hoisted_5 = { class: "col-md-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_7 = { class: "col-md-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institute", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "col-md-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Start Date")
], -1)
const _hoisted_12 = { class: "col-md-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "End Date")
], -1)
const _hoisted_14 = {
  class: "col-md-2 mt-2",
  style: {"width":"auto"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_16 = { class: "col-md-2 mt-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "card-body p-0"
}
const _hoisted_19 = {
  style: {"float":"right"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_26 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Training Partner"),
    /*#__PURE__*/_createElementVNode("th", null, "Training Provider"),
    /*#__PURE__*/_createElementVNode("th", null, "Total NID"),
    /*#__PURE__*/_createElementVNode("th", null, "Enrolled")
  ])
], -1)
const _hoisted_28 = { style: {} }
const _hoisted_29 = { class: "text-start" }
const _hoisted_30 = { class: "text-start" }
const _hoisted_31 = { class: "text-start" }
const _hoisted_32 = { class: "text-start" }
const _hoisted_33 = { class: "border border-gray-400 text-center" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "fw-bold"
}, " Subtotal ", -1)
const _hoisted_35 = { class: "fw-bold text-start" }
const _hoisted_36 = { class: "fw-bold text-start" }
const _hoisted_37 = { class: "border border-gray-400 text-center" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "fw-bold"
}, "Total", -1)
const _hoisted_39 = { class: "fw-bold text-start" }
const _hoisted_40 = { class: "fw-bold text-start" }
const _hoisted_41 = {
  key: 1,
  class: "card-body p-0"
}
const _hoisted_42 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Training Partner"),
    /*#__PURE__*/_createElementVNode("th", null, "Training Provider"),
    /*#__PURE__*/_createElementVNode("th", null, "Total NID"),
    /*#__PURE__*/_createElementVNode("th", null, "Enrolled")
  ])
], -1)
const _hoisted_44 = { style: {} }
const _hoisted_45 = { class: "text-start" }
const _hoisted_46 = { class: "text-start" }
const _hoisted_47 = { class: "text-start" }
const _hoisted_48 = { class: "text-start" }
const _hoisted_49 = { class: "border border-gray-400 text-center" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "fw-bold"
}, "Total", -1)
const _hoisted_51 = { class: "fw-bold text-start" }
const _hoisted_52 = { class: "fw-bold text-start" }
const _hoisted_53 = {
  key: 2,
  class: "card-body p-0"
}
const _hoisted_54 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_55 = { class: "card-body p-0" }
const _hoisted_56 = {
  style: {"float":"right"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_63 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Training Partner"),
    /*#__PURE__*/_createElementVNode("th", null, "Training Provider"),
    /*#__PURE__*/_createElementVNode("th", null, "NID"),
    /*#__PURE__*/_createElementVNode("th", null, "Created At")
  ])
], -1)
const _hoisted_65 = { style: {} }
const _hoisted_66 = { class: "text-start" }
const _hoisted_67 = { class: "text-start" }
const _hoisted_68 = { class: "text-start" }
const _hoisted_69 = { class: "text-start" }
const _hoisted_70 = { class: "border border-gray-400 text-center" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Total ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.entity_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity_id) = $event)),
            options: _ctx.optionsTPartner,
            mode: "tags",
            "clear-on-select": false,
            placeholder: "Select Training Partner",
            "close-on-select": false,
            searchable: true,
            "create-option": true
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _createVNode(_component_el_select, {
            class: "form-select-solid",
            placeholder: "Select Training Institute",
            modelValue: _ctx.institute_id,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.institute_id) = $event)),
            filterable: "",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "--Select--",
                value: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("--Select--")
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: inst.id,
                  label: inst.institute_name,
                  value: inst.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(inst.institute_name), 1)
                  ]),
                  _: 2
                }, 1032, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_el_form_item, {
            prop: "date",
            class: "mb-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.start_date,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.start_date) = $event)),
                "value-format": "YYYY-MM-DD",
                format: "DD-MM-YYYY",
                type: "date",
                style: {"width":"100%"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_el_form_item, {
            prop: "date",
            class: "mb-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.end_date,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.end_date) = $event)),
                "value-format": "YYYY-MM-DD",
                format: "DD-MM-YYYY",
                type: "date",
                style: {"width":"100%"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.nidList())),
            type: "button",
            class: "btn btn-success mt-6 p-3",
            style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
          }, [
            _createTextVNode(" Search "),
            _hoisted_15
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.nidReport())),
            type: "button",
            class: "btn btn-primary mt-6 p-3",
            style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
          }, [
            _createTextVNode(" Show All "),
            _hoisted_17
          ])
        ])
      ]),
      (_ctx.nidreportallstatus)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                title: "Download Xlse",
                "data-v-54b12dc8": "",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportTrainee()))
              }, _hoisted_21),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                title: "Download PDF",
                "data-v-54b12dc8": "",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downloadPdf()))
              }, _hoisted_23),
              _hoisted_24,
              _hoisted_25
            ]),
            _createElementVNode("table", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("tbody", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.nidReportAll, (info, key) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.institutes, (institute, key2) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: key2,
                        class: "border border-gray-400 text-center"
                      }, [
                        _createElementVNode("td", _hoisted_29, " [" + _toDisplayString(info?.entity_short_name) + "] - " + _toDisplayString(info?.entity_name), 1),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(institute?.institute_name), 1),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(institute?.totalnid), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(institute?.enroll), 1)
                      ]))
                    }), 128)),
                    _createElementVNode("tr", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("td", _hoisted_35, _toDisplayString(Number(info?.totalnid).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(Number(info?.enroll).toLocaleString()), 1)
                    ])
                  ], 64))
                }), 128)),
                _createElementVNode("tr", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("td", _hoisted_39, _toDisplayString(Number(this.TotalNid).toLocaleString()), 1),
                  _createElementVNode("td", _hoisted_40, _toDisplayString(Number(this.TotalEnroll).toLocaleString()), 1)
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.tabLoad]
          ])
        : _createCommentVNode("", true),
      (_ctx.nidreportstatus)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_41, [
            _createElementVNode("table", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("tbody", _hoisted_44, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.nidReportInfo, (info, key) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: key,
                    class: "border border-gray-400 text-center"
                  }, [
                    _createElementVNode("td", _hoisted_45, " [" + _toDisplayString(info?.entity_short_name) + "] - " + _toDisplayString(info?.entity_name), 1),
                    _createElementVNode("td", _hoisted_46, _toDisplayString(info?.institute_name), 1),
                    _createElementVNode("td", _hoisted_47, _toDisplayString(info?.totalnid), 1),
                    _createElementVNode("td", _hoisted_48, _toDisplayString(info?.enroll), 1)
                  ]))
                }), 128)),
                _createElementVNode("tr", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("td", _hoisted_51, _toDisplayString(this.TotalNid), 1),
                  _createElementVNode("td", _hoisted_52, _toDisplayString(this.TotalEnroll), 1)
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.tabLoad]
          ])
        : _createCommentVNode("", true),
      (_ctx.nidliststatus)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                      title: "Download Xlse",
                      "data-v-54b12dc8": "",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.exportTraineenext()))
                    }, _hoisted_58),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                      title: "Download PDF",
                      "data-v-54b12dc8": "",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downloadPdfnext()))
                    }, _hoisted_60),
                    _hoisted_61,
                    _hoisted_62
                  ]),
                  _createElementVNode("table", _hoisted_63, [
                    _hoisted_64,
                    _createElementVNode("tbody", _hoisted_65, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.nidListInfo, (info, key) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: key,
                          class: "border border-gray-400 text-center"
                        }, [
                          _createElementVNode("td", _hoisted_66, " [" + _toDisplayString(info?.entity_info?.entity_short_name) + "] - " + _toDisplayString(info?.entity_info?.entity_name), 1),
                          _createElementVNode("td", _hoisted_67, _toDisplayString(info?.institute_info?.institute_name), 1),
                          _createElementVNode("td", _hoisted_68, _toDisplayString(info?.nid), 1),
                          _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.moment(info?.created_at).format('DD-MM-YYYY')), 1)
                        ]))
                      }), 128)),
                      _createElementVNode("tr", _hoisted_70, [
                        _hoisted_71,
                        _createElementVNode("td", null, _toDisplayString(this.nidListTotal), 1)
                      ])
                    ])
                  ])
                ])
              ]))
            ])
          ])), [
            [_directive_loading, _ctx.tabLoad]
          ])
        : _createCommentVNode("", true)
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}